import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { type ForwardedRef, forwardRef } from "react";

const LinkImpl = ((props, ref: ForwardedRef<HTMLSpanElement>) => {
  return <TextV2 css={rootStyles} {...props} ref={ref} />;
}) as typeof TextV2;

export const Link = forwardRef(
  // @ts-ignore
  LinkImpl,
) as unknown as typeof LinkImpl;

const rootStyles = (theme: ExactTheme) =>
  css({
    color: theme.colorsV2.blue[500],
    ":hover": {
      color: theme.colorsV2.blue[600],
    },
    textDecoration: "underline",
    cursor: "pointer",
  });
